<div class="card">
  <h5 class="card-header"></h5>
  <div class="card-body">
    <a [routerLink]="['/']">
      <img id="app-logo" class="logo-image" src="content/images/logo.png" alt="Leanbyte Logo" />
    </a>
    <h5 class="card-title">
      {{ 'landingPage.greeting' | translate }} <span>{{ userName }}</span>
    </h5>
    <div id="app">
      <div>403</div>
      <div class="txt">
        <span><i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i> ACCESS DENIED</span>
      </div>
    </div>
    <p class="card-text">{{ 'landingPage.welcome' | translate }}</p>
  </div>
</div>
